/** 分析用物料狀態（manufacturing-command-status）。 */

export const MATERIAL_STATUS = {
  READY: 'READY',
  RISK: 'RISK',
  BLOCKED: 'BLOCKED',
  DATA_ERROR: 'DATA_ERROR',
};

export const MATERIAL_STATUS_LABELS = {
  READY: '就緒',
  RISK: '有風險',
  BLOCKED: '阻塞',
  DATA_ERROR: '資料異常',
};

export const MATERIAL_STATUS_CLASS = {
  READY: 'border-transparent bg-emerald-600 text-emerald-50',
  RISK: 'border-transparent bg-amber-600 text-amber-50',
  BLOCKED: 'border-transparent bg-rose-600 text-rose-50',
  DATA_ERROR: 'border-transparent bg-slate-600 text-slate-50',
};

/** 可點時 hover／focus-visible：底色淺一階、字色更亮（禁 ring／brightness／弱 opacity） */
export const MATERIAL_STATUS_INTERACTIVE_CLASS = {
  READY:
    'hover:bg-emerald-500 hover:text-white focus-visible:bg-emerald-500 focus-visible:text-white',
  RISK:
    'hover:bg-amber-500 hover:text-white focus-visible:bg-amber-500 focus-visible:text-white',
  BLOCKED:
    'hover:bg-rose-500 hover:text-white focus-visible:bg-rose-500 focus-visible:text-white',
  DATA_ERROR:
    'hover:bg-slate-500 hover:text-white focus-visible:bg-slate-500 focus-visible:text-white',
};

export const MATERIAL_STATUS_FILTER_OPTIONS = [
  { value: 'READY', label: '就緒' },
  { value: 'RISK', label: '有風險' },
  { value: 'BLOCKED', label: '阻塞' },
  { value: 'DATA_ERROR', label: '資料異常' },
];

export function formatMaterialStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return MATERIAL_STATUS_LABELS[status] ?? status;
}
